import { useTranslation } from "@outschool/localization";
import { useQueryWithPreviousData } from "@outschool/ui-apollo";
import { searchListingsQuery } from "@outschool/ui-components-website";
import { Loading } from "@outschool/ui-legacy-component-library";
import React from "react";

import * as Env from "../../../../shared/Env";
import { makeCardDefinition } from "../../../../shared/parentDashboard/cardTypes/Topic";
import {
  SpecialCardDefinitions,
  TopicDefinitions
} from "../../../../shared/parentDashboard/cardTypes/TopicDefinitions";
import { seededShuffle } from "../../../../shared/Random";
import * as PreferredTimes from "../cardTypes/PreferredTimes";
import { usePreferredTimeRange } from "../cardTypes/PreferredTimes";
import * as Topic from "../cardTypes/Topic";
import TabContent from "./TabContent";

export default function TrendingTab({ learners, random }: $TSFixMe) {
  const { t } = useTranslation(
    "client\\components\\parentDashboard\\tabs\\TrendingTab"
  );

  // For classes, show a random assortment of 50 classes that are within the 100 most popular that week with learners of the same age as the user
  const learnerAges = learners
    .map((learner: $TSFixMe) => learner.age)
    .join(",");
  const { loading, data } = useQueryWithPreviousData(searchListingsQuery, {
    skip: !!Env.FEATURE_FLAGS.DISABLE_OPTIONAL_QUERIES,
    variables: {
      searchFilters: { age: learnerAges, order: "popular", isAvailable: true },
      limit: 100,
      skipRating: false,
      withRecentReviews: false
    },
    context: { doNotRetry: true }
  });
  const listingsTopHundred = data?.searchListings?.listings;
  const listingsShuffled = loading
    ? []
    : seededShuffle(random, listingsTopHundred);
  const listings = listingsShuffled.slice(0, 50);

  // For carousels, show any seasonal carousels as the top ones first. Then show any of the Daytime, Weekend, and After School carousels that apply. Then at the end show up to 5 more carousels for randomly selected topics that were aong the 10 most popular in the last 7 days with learners the same age as the user’s.
  const carousels = [];
  carousels.push(
    // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
    ...SpecialCardDefinitions.filter(
      c => c.id != "bestsellers-starting-soon"
    ).map(td => (
      <Topic.Component
        card={{ ...makeCardDefinition(td), display: "list" }} // eslint-disable-line i18next/no-literal-string
        trackingProperties={{}}
        loadAfterDelay={0}
      />
    ))
  );
  // check if user has a time preference, then add preferred time carousel
  const userTimePreference = usePreferredTimeRange(random);
  if (!!userTimePreference) {
    // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
    carousels.push(<PreferredTimes.Component random={random} />);
  }
  const topicCarousels = seededShuffle(random, TopicDefinitions)
    .slice(0, 5)
    .map(td => (
      <Topic.Component
        key={`carousel-topic-${td.id}`}
        // @ts-ignore TS(2345): Argument of type '{ id: string; title: "Acting and... Remove this comment to see the full error message
        card={{ ...makeCardDefinition(td, true), display: "list" }} // eslint-disable-line i18next/no-literal-string
        trackingProperties={{}}
        loadAfterDelay={0}
      />
    ));
  // @ts-ignore TS(2345): Argument of type 'Element' is not assignable to pa... Remove this comment to see the full error message
  carousels.push(...topicCarousels);

  return loading ? (
    <Loading />
  ) : (
    <TabContent
      title={t("Trending classes and topics")}
      // @ts-ignore TS(2322): Type 'unknown[]' is not assignable to type 'never[... Remove this comment to see the full error message
      listings={listings}
      listingsLoading={loading}
      carousels={carousels}
    />
  );
}
